import Script from 'next/script';
import {
  generateGoogleTagManagerScriptBlock,
  generateWindowDatalayerScript,
} from '../generateGoogleTagManagerScriptBlocks';

type Props = {
  googleTagManagerId: string;
  query: string;
};

const GoogleTagManagerAndCookieConsent = ({
  googleTagManagerId,
  query,
}: Props) => {
  return (
    <>
      <Script
        src={`${process.env.NEXT_PUBLIC_BREEZE_URL}/consent/tarteaucitron.min.js`}
        strategy="beforeInteractive"
      />
      <Script
        src={`${process.env.NEXT_PUBLIC_BREEZE_URL}/consent/initTarteaucitron.js`}
        strategy="beforeInteractive"
      />

      <script
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html: `
               ${generateWindowDatalayerScript({
                 query,
               })}`,
        }}
      />
      {
        <Script
          dangerouslySetInnerHTML={{
            __html: generateGoogleTagManagerScriptBlock({
              googleTagManagerId,
            }),
          }}
        />
      }
      <link
        type="text/css"
        href={`${process.env.NEXT_PUBLIC_BREEZE_URL}/consent/css/tarteaucitron-overrides.css`}
        rel="stylesheet"
      />
    </>
  );
};

export default GoogleTagManagerAndCookieConsent;
